import Byte from './Integers/Byte';
export default function asByte(value) {
    return new Byte(value);
}
